import { Time } from "../../../../../../bayadic-shared-models/tools/Tools";
import { AbstractChatMessage } from "../../../../../../bayadic-shared-models/classes/message/abstract-chat-message";
import { ChatMessage } from "../../../../../../bayadic-shared-models/classes/message/chat-message";
import { User } from "../../../../../../bayadic-shared-models/classes/user/User";
import { MessageFactory } from "./message-factory";
import { ITEM_TYPES } from "../../../../../../bayadic-shared-models/item/item-types";
import { MESSAGE_TYPES } from "../../../../../../bayadic-shared-models/item/message-types";

export class MessageBuilder {
    scheduledTime(scheduledTime: Date) {
        this.message.scheduledTime = scheduledTime
        return this;
    }
    message: AbstractChatMessage;
    type(messageType: MESSAGE_TYPES){
        const messageFactory = new MessageFactory();
        this.message = messageFactory.getMessage(messageType)
        return this;
    }
    content(content: any){
        if(this.message.isDictionaryMessage() && typeof content === typeof "string"){
            this.message.setContent({title: content})
        }
        else if(this.message.isLeitnerMessage()){
            try {
                const leitnerContent = JSON.parse(content);
                this.message.setContent(leitnerContent)
            }
            catch (e) {
                this.message.setContent(content)
            }
        }
        else if(this.message.isLesson()){
            // this.logger.debug('content: ', content);
            // const lessonContent = JSON.parse(content);
            this.message.setContent(content)
        }
        else {
            this.message.setContent(content)
        }
        return this;
    }
    from(user: User){
        this.message.from = user;
        return this;
    }  
    title(title:string){
        this.message.content.title = title
        return this
    }
    time(time: Date){
        this.message.timestamp  = time
        return this
    } 
    messageID(messageID: string){
        this.message.messageID = messageID
        return this
    }
    chatID(messageID: string){
        this.message.chatID = messageID
        return this
    } 
    build(){
        this.message.receivedTime = Time.getTimeString()
        this.message.setStatus(this.message.possibleStatuses.created)
        return this.message
    }
    reset(){
        this.message = new ChatMessage()
    }

    // createMessageOfType(msgType: string): Message {
    //     let message;
    //     switch (msgType) {
    //       case "chat":
    //         message = new Message({
    //           text: this.msg, content: [],
    //           type: this.msgType,
    //           from: this.userManager.user,
    //           receivedTime: Tools.Time.getTimeString()
    //         });
    //         break;
    //       case "dictionary":
    //         message = new Message({
    //           text: this.msg.trim(),
    //           content: [],
    //           type: this.msgType,
    //           from: this.userManager.user,
    //           receivedTime: Tools.Time.getTimeString()
    //         });
    //         break;
    //       case "leitner":
    //         message = new Message({
    //           text: this.msg, content: [],
    //           type: this.msgType,
    //           from: this.userManager.user,
    //           receivedTime: Tools.Time.getTimeString()
    //         });
    //         break;
    //       case "artikelQuiz":
    //         message = new QuizMessage({
    //           text: this.msg,
    //           content: [],
    //           type: this.msgType,
    //           from: this.userManager.user,
    //           receivedTime: Tools.Time.getTimeString()
    
    //         });
    //         this.logger.debug('message in  createMessageOfType(msgType: string): ', message);
    //         break;
    //       case "imageQuiz":
    //       case "translationQuiz":
    //         message = new QuizMessage({
    //           text: this.msg,
    //           content: [],
    //           type: this.msgType,
    //           from: this.userManager.user,
    //           receivedTime: Tools.Time.getTimeString()
    //         });
    //         break;
    //     }
    //     return message;
    //   }
}